const {Core, Events, Utils} = Global;
const {$state} = Utils;
const PREFIX_BUY_WITH = 'buy_with_'
customElements.define('product-form', class extends Core {
    propTypes = {
        'multiple-products': Boolean
    }
    elements = {
        toCartButton: 'product-to-cart',
        form: '[data-type=add-to-cart-form]',
        $: ['button-unavailable']
    }
    render() {
        this.$('form', {
            submit: this._submitHandler
        });
        this.sub(Events.VARIANT_UNAVAILABLE, this._setUnavailable)
    }
    _setUnavailable(state) {
        $state(this, 'unavailable', state)
    }
    _submitHandler(e) {
        e.preventDefault();
      //hulk validation first half start
const validateObjectData = validate_options(window.hulkapps.product_id);
        console.log(`validateObjectData -- ${validateObjectData}`);
const validateObjectValue = async () => {
  const vod = await validateObjectData;
  console.log(`vod -- ${vod}`);
  if (vod == true) {
//hulk validation first half end

        this._validateForm();
        this.prop('multiple-products') ? this.$('toCartButton').addToCart(this.cartItems) : this.pub(Events.PRODUCT_FORM_SUBMIT, {
            formData: this.formData
        })

    //hulk validation second half start
  }
   console.log(`vod -- ${this.$('toCartButton').classList.remove('!loading')}`);
    document.querySelector('.shopify-product-form product-to-cart button').classList.remove('!loading');
};
      validateObjectValue();
//hulk validation second half end

    }
    _validateForm() {
        this.formData = this._getFormData();
        for (const [key, value] of [...this.formData.entries()]) {
            // If value is a string, trim it
            if (typeof value === 'string' && value.trim() === '') {
                this.formData.delete(key);
            }
            // If it's a FileList (like from input type="file") and it's empty
            else if (value instanceof FileList && value.length === 0) {
                this.formData.delete(key);
            }
        }
    }
    _isVariantInput([inputName]) {
        return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id'
    }
    _setCartItem([_,value]) {
        return {
            id: value,
            quantity: 1
        }
    }
    _getFormData() {
        return new FormData(this.$('form'))
    }
    get cartItems() {
        return Array.from(this.formData.entries()).filter(this._isVariantInput.bind(this)).map(this._setCartItem.bind(this))
    }
}
)
